"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var TreeNodeDirection;
(function (TreeNodeDirection) {
    TreeNodeDirection[TreeNodeDirection["LEFT"] = 0] = "LEFT";
    TreeNodeDirection[TreeNodeDirection["RIGHT"] = 1] = "RIGHT";
})(TreeNodeDirection || (TreeNodeDirection = {}));
exports.default = TreeNodeDirection;
//# sourceMappingURL=tree-node-direction.js.map